<template>
  <div v-if="stream && stream.streamTheme">
    <e-tooltip :tooltips="tooltipText | lowerCase | capitalize">
      <img
        slot="tooltip-text"
        :src="$helpers.getStreamIcon(stream)"
        :alt="tooltipText"
        width="24"
        height="24"
        class="mr-2"
      >
    </e-tooltip>
  </div>
</template>

<script>
export default {
  name: 'StreamIcon',

  props: {
    stream: {
      type: Object,
      required: true
    }
  },

  computed: {
    tooltipText() {
      return this.stream.streamTheme === 'basic' ? 'Content Stream' : this.stream.streamTheme
    }
  }
}
</script>
